// extracted by mini-css-extract-plugin
export default {"qtySection":"CartProduct_qtySection__-+3g8","qtyBtn":"CartProduct_qtyBtn__qvfHY","qtyInput":"CartProduct_qtyInput__PfDJ7","disableBtn":"CartProduct_disableBtn__ev-tz"};